import { getComponentFromName } from '../../lib/utils';

import { GameProvider } from '../../contexts/GameContext';
import * as GamesComponents from './index';

interface GameProps {
    game: Game;
    participation: Participation | null;
}

function Game({ game, participation, ...props }: GameProps) {
    const { type } = game || {};
    const GameComponent = getComponentFromName(GamesComponents, type) || null;
    return (
        <GameProvider game={game} participation={participation}>
            {GameComponent !== null ? (
                <GameComponent game={game} participation={participation} {...props} />
            ) : null}
        </GameProvider>
    );
}

export default Game;
